<div class="body">
    <div class="titulo">
        ¡Suscribase a nuestro portal de noticias!
    </div>

    <div class="row mt-5">
        <div class="col-lg-6 form">
            <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Correo Electrónico</mat-label>
                <input matInput [(ngModel)]='model.email' placeholder="Inserte su correo electrónico">
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Nombre</mat-label>
                <input matInput [(ngModel)]='model.name' placeholder="Inserte su nombre">
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Primer Apellido</mat-label>
                <input matInput [(ngModel)]='model.lastname' placeholder="Inserte su apellido">
            </mat-form-field>

            <div class="example-full-width">
                <p>Fecha de Nacimiento</p>
                <ngb-datepicker class="example-full-width" #dp [(ngModel)]='fechaNacimientoPlaceholder'
                    (navigate)="date = $event.next" [minDate]="{year: 1920, month: 1, day: 1}">
                </ngb-datepicker>
                <form class="form-inline example-full-width">
                    <div class="form-group example-full-width">
                        <div class="input-group example-full-width">
                            <input class="form-control inputControl example-full-width" placeholder="aaaa-mm-dd"
                                disabled name="dp" [(ngModel)]='fechaNacimientoPlaceholder' ngbDatepicker
                                #d="ngbDatepicker" type="text" id="filerAddress">
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="tituloCategoriasMini">
                Elija categorías a las que desea suscribirse:
            </div>
            <div class="subtitulo mt-3">
                Estamos desarrollando un portal donde se le notificara a cada uno de nuestro clientes acerca del tema o
                de las categorías a las que se seleccione
            </div>
            <div class="grid">
                <div class="seleccion" *ngFor="let item of categorys | async">
                    <mat-checkbox class="checkboxSize" color="warn" (change)="valueChange(item, $event)">{{item.name}}
                    </mat-checkbox>
                </div>
            </div>
        </div>
    </div>

    <div class="centreadoBoton">
        <button mat-raised-button color="warn" (click)='subscribe()'>SUSCRIBIRSE</button>
    </div>

    <footer>
        <app-footer-new></app-footer-new>
    </footer>
</div>
